import SmeFrsList from '@/pages/components/manage/dictionary/sme-frs/SmeFrsList';

export default {
    list: SmeFrsList,
    recordRepresentation: 'content',
};
